import React, { useContext, useState } from 'react'
import styled from 'styled-components'
import { AuthContext } from '../../../../auth-context'
import Button from '../../../../components/button'
import { getPortalTeamupAuthURI, revokePortalTeamupAccess } from '../../../../api'
import SettingsEthernet from '@material-ui/icons/SettingsEthernet'

const TeamUpContainer = styled.div`
background: #FFF;
border-radius: 8px;
box-shadow: 0px 0px 8px 0px #e1e2e6;
width: 100%;
padding: 24px;

@media(max-width: 900px) {
  padding: 16px;
}
`

const Label = styled.label`
  color: #555;
  display: flex;
  align-items: center;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 24px;

  svg {
    fill: #555;
    height: auto;
    width: 36px;
    margin-right: 16px;
  }

  @media(max-width: 900px) {
    font-size: 1.25rem;
    margin-bottom: 16px;

    svg {
      width: 28px;
    }
  }
`
const ButtonContainer = styled.div`
background: #FFF;
width: 100%;
`

const TeamUp = () => {
  const [busy, setBusy] = useState(false)
  const { user, updateUser } = useContext(AuthContext)

  const connectToTeamup = () => {
    setBusy(true)
    getPortalTeamupAuthURI(user.id).then((res) => {
      window.location.href = res.data.uri
    })
  }

  const disconnectFromTeamup = () => {
    setBusy(true)
    revokePortalTeamupAccess(user.id).then((res) => {
      setBusy(false)
      updateUser(Object.assign({}, user, { teamup_connected: false }))
    })
  }

  return (
    <TeamUpContainer>
      <Label>
        <SettingsEthernet /> TeamUp Connection
      </Label>
      {user.teamup_connected ? (
        <ButtonContainer>
          <p>You are connected to TeamUp.</p>
          <Button 
            label="Disconnect from TeamUp"
            isLoading={busy}
            disabled={busy}
            onClick={disconnectFromTeamup}
          />
        </ButtonContainer>
      ) : (
        <ButtonContainer>
          <p>You are not connected to TeamUp.</p>
          <Button 
            label="Connect to TeamUp"
            isLoading={busy}
            disabled={busy}
            onClick={connectToTeamup}
          />
        </ButtonContainer>
      )}
    </TeamUpContainer>
  )
}

export default TeamUp
